<template>
  <div>
    <el-form :model="form" :inline="true" size="mini" class="form-wrapper">
      <el-form-item style="float: right;">
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button type="warning" @click="onReset">重置</el-button>
        <el-button type="warning" @click="add">新增</el-button>
        <el-button type="blue" @click="onExport">导出</el-button>
      </el-form-item>
      <el-form-item label="产品编码">
        <el-input v-model.trim="form.productCode"></el-input>
      </el-form-item>
      <el-form-item label="产品名称">
        <el-input v-model.trim="form.productName"></el-input>
      </el-form-item>
    </el-form>
    <add v-model="addVisible" v-if="addVisible" @complete="onSearch"></add>
  </div>
</template>

<script>
import add from './add'
export default {
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: ['formData'],
  components: {add},
  data() {
    return {
      collapse: false,
      form: {},
      addVisible: false
    }
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    onSearch() {
      this.$emit('search', this.form)
    },
    onReset() {
      this.form = {};
      this.$nextTick(_=>{
        this.onSearch();
      })
    },
    // 导出 --新接口
    onExport() {
      let params = {
        appCode: "ec-pc-new",
        paramMap: {
          ...this.form
        },
        reportName: "whiteListExport",
      };
      this.$q.common.exportExcel({data: params}).then((res) => {
        this.$message({
          type: "success",
          message: "导出成功,请在导出列表中查看",
        });
      });
    },
    add() {
      this.addVisible = true;
    }
  },
}
</script>
<style lang="stylus" scoped>
  .form-wrapper
    width 100%
    margin-top 15px
    >>> .el-form-item
      margin-bottom 10px

    >>> .el-input
      width 110px !important
    
    >>> .el-date-editor,>>> .el-date-editor input
      width 120px !important
    >>> .el-date-editor input
      padding-right 10px

    >>> .el-button--blue
      color #ffffff
      background-color #00A8E8
      border-color #00A8E8
</style>